import { createFileRoute, redirect } from '@tanstack/react-router'
import type { TeamSection } from '@/components/settings/team-sidebar'

export const Route = createFileRoute('/_app/_settings/staff')({
  validateSearch: (search: Record<string, unknown>) => {
    return { section: search.section as string | undefined }
  },
  beforeLoad: () => {
    throw redirect({ to: '/team', search: { section: 'team' as TeamSection } })
  },
})
